import { render, staticRenderFns } from "./Footr.vue?vue&type=template&id=8dc59bd4&"
import script from "./Footr.vue?vue&type=script&lang=js&"
export * from "./Footr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports